import React, { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";
import API from "../../apiService.js";
import ALERT from "../component/Alert";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import apiService from "../../apiService";
const SignupSchema = Yup.object().shape({
  weight: Yup.number()
    .typeError("berat badan harus berupa angka")
    .integer(" berat badan harus angka")
    .positive(" berat badan harus lebih dari 0")
    .required("berat badan  berat Badan belum diisi"),
  height: Yup.number()
    .typeError("tinggi badan harus berupa angka")
    .integer(" tinggi badan harus angka")
    .positive(" tinggi badan harus lebih dari 0")
    .required("tinggi badan belum diisi"),
  sistole: Yup.number()
    .typeError("sistole harus berupa angka")
    .integer(" sistole harus angka")
    .positive(" sistole harus lebih dari 0")
    .required("sistole belum diisi"),
  diastole: Yup.number()
    .typeError("diastole harus berupa angka")
    .integer(" diastole  harus angka")
    .positive(" diastole harus lebih dari 0")
    .required("diastole belum diisi"),
  pulse: Yup.number()
    .typeError("nadi harus berupa angka")
    .integer(" nadi  harus angka")
    .positive(" nadi harus lebih dari 0")
    .required("nadi belum diisi"),
  respiration: Yup.number()
    .typeError("pernapasan harus berupa angka")
    .integer(" pernapasan  harus angka")
    .positive(" pernapasan harus lebih dari 0")
    .required("pernapasan belum diisi"),
});

export class KbObjective extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kd_sadar: this.props.patient.kd_sadar,
      refBlood: [],
      data:
        props.patient.examinations.length > 0
          ? props.patient.examinations[0]
          : [],
      refHambatan: [
        { name: "Budaya", status: false },
        { name: "Bahasa", status: false },
        { name: "Fisik", status: false },
        { name: "Religi", status: false },
      ],
      hambatan: [],
      hambatanCheked:
        props.patient.examinations[0].hambatan.length > 1
          ? props.patient.examinations[0].hambatan
          : "",
    };
    this.onChangeHambatan = this.onChangeHambatan.bind(this);
  }

  async getKb() {
    const res = await apiService.get(`registration/kb/read/${this.state.data.visit_id ?? 0}`)
    if (res.code === 200 && res.data.length) {
      this.setState({data: {
        ...this.state.data,
        husband_name: res.data[0].husband_name,
        husband_education_id: res.data[0].husband_education_id,
        husband_job_id: res.data[0].husband_job_id,
        number_of_son_alive: res.data[0].number_of_son_alive,
        number_of_daughter_alive: res.data[0].number_of_daughter_alive,
        youngest_child_birth: res.data[0].youngest_child_birth,
        kb_participant_status: res.data[0].kb_participant_status,
        contraceptive_id: res.data[0].contraceptive_id,
        latest_contraceptive_id: res.data[0].latest_contraceptive_id,
        last_menstruation: res.data[0].last_menstruation,
        is_pregnant: res.data[0].is_pregnant,
        g: res.data[0].g,
        p: res.data[0].p,
        a: res.data[0].a,
        breast_feed: res.data[0].breast_feed,
        jaundice: res.data[0].jaundice,
        vaginal_bleeding: res.data[0].vaginal_bleeding,
        puerperal: res.data[0].puerperal,
        long_vaginal_discharge: res.data[0].long_vaginal_discharge,
        breast_tumor: res.data[0].breast_tumor,
        ovarian_tumor: res.data[0].ovarian_tumor,
        uterine_tumor: res.data[0].uterine_tumor,
        reorder_date: res.data[0].reorder_date,
      }})
    }
    else if (res.data.code === 404) {
      const res = await apiService.get(`registration/kb/previous/${this.state.data.visit_id ?? 0}`)
      if (res.code === 200) {
        this.setState({data: {
          ...this.state.data,
          husband_name: res.data[0].husband_name,
          husband_education_id: res.data[0].husband_education_id,
          husband_job_id: res.data[0].husband_job_id,
          number_of_son_alive: res.data[0].number_of_son_alive,
          number_of_daughter_alive: res.data[0].number_of_daughter_alive,
          youngest_child_birth: res.data[0].youngest_child_birth,
          g: res.data[0].g,
          p: res.data[0].p,
          a: res.data[0].a,
        }})
      }
    }
  }

  componentDidMount() {
    this.hambatanCheked();
    this.getBloodType();
    this.getJob();
    this.getEducation();
    this.getContraceptive();
    this.getKb();
  }

  async getJob() {
    let res = await apiService.get("/management/jobs/read");
    if (res && res.code === 200) {
      this.setState({
        refJob: res.data,
      });
    }
  };

  async getEducation() {
    let res = await apiService.get("/management/educations/read");
    if (res && res.code === 200) {
      this.setState({
        refEducation: res.data,
      });
    }
  };

  async getContraceptive() {
    try {
      let res = await apiService.get("/management/contraceptives/read");
      if (res && res.code === 200) {
        this.setState({
          refContraceptive: res.data,
        });
      }
    }
    catch (e) {
      console.log(e)
    }
  };

  hambatanCheked() {
    const x = this.state.hambatanCheked;
    const refHambatanNow = this.state.refHambatan;
    let y = [];
    const refHambatan = [];

    if (x.length > 0) {
      y = x.split(",");
      this.setState({ hambatan: y });
      y.map((m, s) => {
        // y[s] = { name: m, status: true };
        refHambatanNow.map((a, b) => {
          if (a.name === m) {
            refHambatan[b] = a;
            refHambatan[b].status = true;
            this.setState({ [refHambatan[b]]: refHambatan[b] });
          }
        });
        // refHambatan.status = true;
      });
    }

    // this.setState({ refHambatan: z });
  }

  getBloodType = async () => {
    const res = await API.get("management/blood_types/read");
    if (res.code === 200) {
      this.setState({
        refBlood: res.data,
      });
    }
  };

  handleChangeText = (event) => {
    const value = event.target.value;
    const object = event.target.name;
    console.log({object, value})
    let data;
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [object]: value, // update the value of specific key
      },
    }));
    data = { data: [this.state.data], param: "examinations" };
    this.props.parentCallback(data);
  };

  handleSubmit = async () => {
    var param = this.state.data;
    const res = await API.put("registration/examination/update", param);
    if (res.code === 200) {
      try {
        const d = {
          "id" : this.state.data.id,
          "visit_id" : this.state.data.visit_id ?? 0,
          "husband_name" : this.state.data.husband_name ?? "",
          "husband_education_id" : this.state.data.husband_education_id ?? 8,
          "husband_job_id" : this.state.data.husband_job_id ?? 2,
          "number_of_son_alive" : this.state.data.number_of_son_alive ?? 2,
          "number_of_daughter_alive" : this.state.data.number_of_daughter_alive ?? 0,
          "youngest_child_birth" : this.state.data.youngest_child_birth ?? "2020-06-16",
          "kb_participant_status" : this.state.data.kb_participant_status === true || this.state.data.kb_participant_status === 'true',
          "contraceptive_id" : this.state.data.contraceptive_id ?? 1,
          "latest_contraceptive_id" : this.state.data.latest_contraceptive_id ?? 1,
          "last_menstruation" : this.state.data.last_menstruation ?? "2020-06-16",
          "is_pregnant" : this.state.data.is_pregnant === true || this.state.data.is_pregnant === 'true',
          "g" : this.state.data.g ?? 1,
          "p" : this.state.data.p ?? 6,
          "a" : this.state.data.a ?? 2,
          "breast_feed" : this.state.data.breast_feed === true || this.state.data.breast_feed === 'true',
          "jaundice" : this.state.data.jaundice === true || this.state.data.jaundice === 'true',
          "vaginal_bleeding" : this.state.data.vaginal_bleeding === true || this.state.data.vaginal_bleeding === 'true',
          "puerperal" : this.state.data.puerperal === true || this.state.data.puerperal === 'true',
          "long_vaginal_discharge" : this.state.data.long_vaginal_discharge === true || this.state.data.long_vaginal_discharge === 'true',
          "breast_tumor" : this.state.data.breast_tumor === true || this.state.data.breast_tumor === 'true',
          "ovarian_tumor" : this.state.data.ovarian_tumor === true || this.state.data.ovarian_tumor === 'true',
          "uterine_tumor" : this.state.data.uterine_tumor === true || this.state.data.uterine_tumor === 'true',
          "reorder_date" : this.state.data.reorder_date ?? "2020-06-16"
        }
        await API.put('registration/kb/update', d)
      }
      catch (e) {
        console.log(e)
      }

      this.PutVisit();
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  PutVisit = async () => {
    let visit = {
      id: this.props.patient.id,
      kd_sadar: this.state.kd_sadar,
    };
    let res = await API.put(`registration/change/visit`, { visit });
  };

  onChangeHambatan = (idx) => (event) => {
    const target = event.target;
    const refHambatanNow = this.state.refHambatan;
    let refHambatan = [];
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (value) {
      this.setState({
        hambatan: this.state.hambatan.concat([target.value]),
      });
    } else {
      const ham = this.state.hambatan;
      const x = ham.filter((d, sidx) => d.name !== target.name);
      this.setState({
        hambatan: x,
      });
    }

    refHambatan[idx] = refHambatanNow.filter(
      (d, sidx) => d.name === target.name
    );
    refHambatan[idx][0].status = value;
    refHambatan = refHambatan[idx][0];
    this.setState({
      [refHambatan[idx]]: refHambatan,
    });

    setTimeout(
      function () {
        const hambatan = this.state.hambatan;
        const val = hambatan.toString();

        let data;
        this.setState((prevState) => ({
          data: {
            // object that we want to update
            ...prevState.data, // keep all other key-value pairs
            hambatan: val, // update the value of specific key
          },
        }));
        data = { data: [this.state.data], param: "examinations" };

        this.props.parentCallback(data);
      }.bind(this),
      200
    );
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };
  render() {
    var refBlood = this.state.refBlood.map((blood, idx) => {
      return (
        <option key={idx} value={blood.id}>
          {blood.name}
        </option>
      );
    });
    var refHambatan = this.state.refHambatan.map((hambatan, idx) => {
      return (
        <div key={idx} className="row">
          <div className="custom-control custom-checkbox mb-3">
            <input
              className="custom-control-input"
              type="checkbox"
              name={hambatan.name}
              onChange={this.onChangeHambatan(idx)}
              value={hambatan.name}
              id={hambatan.name}
              checked={hambatan.status}
            />
            <label className="custom-control-label" htmlFor={hambatan.name}>
              {hambatan.name}
            </label>
          </div>
        </div>
      );
    });

    return (
      <>
        {this.props.children}
        <Formik
          enableReinitialize
          initialValues={{
            weight: this.state.data.weight,
            height: this.state.data.height,
            sistole: this.state.data.sistole,
            diastole: this.state.data.diastole,
            pulse: this.state.data.pulse,
            respiration: this.state.data.respiration,
            temperature: this.state.data.temperature,
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.handleSubmit();
            this.props.nextTab();
            // same shape as initial values
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <div className="card">
                <div className="card-header"> SKRINING UMUM</div>
                <div className="card-body">
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Berat Badan/Tingi Badan
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="BB"
                          id="weight"
                          name="weight"
                          onChange={this.handleChangeText}
                          value={this.state.data.weight}
                        />
                        <input
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="TB"
                          id="height"
                          name="height"
                          onChange={this.handleChangeText}
                          value={this.state.data.height}
                        />
                        {errors.weight && touched.weight ? (
                          <div style={{ color: "red" }}>
                            &nbsp; {errors.weight}
                          </div>
                        ) : null}

                        {errors.height && touched.height ? (
                          <div style={{ color: "red" }}>
                            &nbsp; {errors.height}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Tekanan Darah
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="sistole"
                          id="sistole"
                          name="sistole"
                          onChange={this.handleChangeText}
                          value={this.state.data.sistole}
                        />
                        <input
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="diastole"
                          id="diastole"
                          name="diastole"
                          onChange={this.handleChangeText}
                          value={this.state.data.diastole}
                        />
                        {errors.sistole && touched.sistole ? (
                          <div style={{ color: "red" }}>
                            &nbsp; {errors.sistole}
                          </div>
                        ) : null}

                        {errors.diastole && touched.diastole ? (
                          <div style={{ color: "red" }}>
                            {" "}
                            &nbsp; {errors.diastole}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Nadi/Pernapasan
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="nadi"
                          id="pulse"
                          name="pulse"
                          onChange={this.handleChangeText}
                          value={this.state.data.pulse}
                        />
                        <input
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="pernapasan"
                          id="respiration"
                          name="respiration"
                          onChange={this.handleChangeText}
                          value={this.state.data.respiration}
                        />
                        {errors.pulse && touched.pulse ? (
                          <div style={{ color: "red" }}>
                            &nbsp; {errors.pulse}
                          </div>
                        ) : null}

                        {errors.respiration && touched.respiration ? (
                          <div style={{ color: "red" }}>
                            &nbsp; {errors.respiration}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Suhu/Golongan darah
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="temp"
                          id="temperature"
                          name="temperature"
                          onChange={this.handleChangeText}
                          value={this.state.data.temperature || 0}
                        />
                        <select
                          className="form-control form-control-sm col-md-6"
                          id="example-text-input"
                          name="blood_type_id"
                          onChange={this.handleChangeText}
                          value={this.state.data.blood_type_id || 0}
                        >
                          {refBlood}
                        </select>
                        {errors.temperature && touched.temperature ? (
                          <div style={{ color: "red" }}>
                            &nbsp; {errors.temperature}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      GCS
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm col-md-4"
                          id="example-text-input"
                          name="gcs_e"
                          defaultValue={this.state.data.gcs_e}
                          onChange={this.handleChangeText}
                        >
                          <option value="4">4</option>
                          <option value="3">3</option>
                          <option value="2">2</option>
                          <option value="1">1</option>
                        </select>
                        <select
                          className="form-control form-control-sm col-md-4"
                          id="example-text-input"
                          name="gcs_v"
                          defaultValue={this.state.data.gcs_v}
                          onChange={this.handleChangeText}
                        >
                          <option value="5">5</option>
                          <option value="4">4</option>
                          <option value="3">3</option>
                          <option value="2">2</option>
                          <option value="1">1</option>
                        </select>
                        <select
                          className="form-control form-control-sm col-md-4"
                          id="example-text-input"
                          name="gcs_m"
                          defaultValue={this.state.data.gcs_m}
                          onChange={this.handleChangeText}
                        >
                          <option value="6">6</option>
                          <option value="5">5</option>
                          <option value="4">4</option>
                          <option value="3">3</option>
                          <option value="2">2</option>
                          <option value="1">1</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Keadaan Umum
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm"
                          id="example-text-input"
                          name="kd_sadar"
                          value={
                            this.state.kd_sadar ? this.state.kd_sadar : "01"
                          }
                          onChange={(val) =>
                            this.setState({
                              kd_sadar: val.target.value,
                            })
                          }
                        >
                          <option>-- Pilih --</option>
                          <option value="01">Compos mentis</option>
                          <option value="02">Somnolence</option>
                          <option value="03">Sopor</option>
                          <option value="04">Coma</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Pemriksaan Fisik
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                          Kepala
                        </label>
                        <input
                          className="form-control form-control-sm col-md-9"
                          type="text"
                          placeholder="kepala"
                          name="kepala"
                          onChange={this.handleChangeText}
                          value={this.state.data.kepala || ""}
                        />
                      </div>
                      <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                          Leher
                        </label>
                        <input
                          className="form-control form-control-sm col-md-9"
                          type="text"
                          placeholder="leher"
                          name="leher"
                          onChange={this.handleChangeText}
                          value={this.state.data.leher || ""}
                        />
                      </div>
                      <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                          Dada
                        </label>
                        <input
                          className="form-control form-control-sm col-md-9"
                          type="text"
                          placeholder="dada"
                          name="dada"
                          onChange={this.handleChangeText}
                          value={this.state.data.dada || ""}
                        />
                      </div>

                      <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                          Perut
                        </label>
                        <input
                          className="form-control form-control-sm col-md-9"
                          type="text"
                          placeholder="perut"
                          name="perut"
                          onChange={this.handleChangeText}
                          value={this.state.data.perut || ""}
                        />
                      </div>
                      <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                          Alat gerak
                        </label>
                        <input
                          className="form-control form-control-sm col-md-9"
                          type="text"
                          placeholder="alat gerak"
                          name="ex_bawah"
                          onChange={this.handleChangeText}
                          value={this.state.data.ex_bawah || ""}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Hambatan
                    </label>
                    <div className="col-md-7 ">{refHambatan}</div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Nama Suami
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="Nama Suami"
                          name="husband_name"
                          onChange={this.handleChangeText}
                          value={this.state.data.husband_name || ''}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Pendidikan Suami
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm"
                          id="example-text-input"
                          name="husband_education_id"
                          value={this.state.data.husband_education_id}
                          onChange={this.handleChangeText}
                        >
                          <option>-- Pilih --</option>
                          {
                            this.state.refEducation?.map((v, k) => (<option value={v.id} key={k}>{v.name}</option>))
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Pekerjaan Suami
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm"
                          id="example-text-input"
                          name="husband_job_id"
                          value={this.state.data.husband_job_id}
                          onChange={this.handleChangeText}
                        >
                          <option>-- Pilih --</option>
                          {
                            this.state.refJob?.map((v, k) => (<option value={v.id} key={k}>{v.name}</option>))
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Jumlah Anak Hidup Laki- Laki
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder=" Jumlah Anak Hidup Laki- Laki"
                          name="number_of_son_alive"
                          defaultValue={this.state.data.number_of_son_alive}
                          onChange={this.handleChangeText}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Jumlah Anak Hidup Perempuan
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder=" Jumlah Anak Hidup Perempuan"
                          name="number_of_daughter_alive"
                          defaultValue={this.state.data.number_of_daughter_alive}
                          onChange={this.handleChangeText}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Tgl Lahir Anak Paling Muda
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm"
                          type="date"
                          placeholder="Tgl Lahir Anak Paling Muda"
                          name="youngest_child_birth"
                          defaultValue={this.state.data.youngest_child_birth}
                          onChange={this.handleChangeText}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Status Peserta KB {this.state.kb_participant_status}
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-3">
                          <input
                            name="kb_participant_status"
                            className="custom-control-input"
                            id="customRadio5"
                            type="radio"
                            value={false}
                            onChange={this.handleChangeText}
                            checked={this.state.data.kb_participant_status === false || this.state.data.kb_participant_status === 'false'}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customRadio5"
                          >
                            Baru
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-3">
                          <input
                            name="kb_participant_status"
                            className="custom-control-input"
                            id="customRadio6"
                            type="radio"
                            value={true}
                            onChange={this.handleChangeText}
                            checked={this.state.data.kb_participant_status === true || this.state.data.kb_participant_status === 'true'}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customRadio6"
                          >
                            Pernah Pakai
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-6">
                          <select
                            className="form-control form-control-sm"
                            id="example-text-input"
                            name="latest_contraceptive_id"
                            value={this.state.data.latest_contraceptive_id}
                            onChange={this.handleChangeText}
                          >
                            <option>-- Kb Terakhir --</option>
                            {
                              this.state.refContraceptive?.map((v, k) => (<option value={v.id} key={k}>{v.name}</option>))
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-md-5 col-form-label col-form-label-sm">
                      Merokok
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm"
                          name="smoke"
                          onChange={this.handleChangeText}
                          value={
                            this.state.data.smoke ? this.state.data.smoke : "0"
                          }
                          // defaultValue={this.state.data.smoke}
                        >
                          <option>-- Pilih --</option>
                          <option value="1">YA</option>
                          <option value="0">Tidak</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Tindakan Yang diberikan
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <textarea
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="Keluhan Pasien"
                          name="physic_anamnese"
                          onChange={this.handleChangeText}
                          value={this.state.data.physic_anamnese}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  {" "}
                  SKRINING UNTUK MENENTUKAN ALAT KB YG COCOK
                </div>
                <div className="card-body">
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Haid Terakhir
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                          className="form-control form-control-sm"
                          type="date"
                          placeholder="Haid Terakhir"
                          name="last_menstruation"
                          value={this.state.data.last_menstruation || ""}
                          onChange={this.handleChangeText}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Diduga hamil
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="is_pregnant"
                              className="custom-control-input"
                              id="customRadio7"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.is_pregnant === true || this.state.data.is_pregnant === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="customRadio7"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="is_pregnant"
                              className="custom-control-input"
                              id="customRadio8"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.is_pregnant === false || this.state.data.is_pregnant === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="customRadio8"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Riwayat Persalinan
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="row">
                            <label className="col-md-3 col-form-label col-form-label-sm">
                              G
                            </label>
                            <input
                                className="form-control form-control-sm col-md-9"
                                type="text"
                                placeholder="G"
                                name="g"
                                value={this.state.data.g || ""}
                                onChange={this.handleChangeText}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <label className="col-md-3 col-form-label col-form-label-sm">
                              P
                            </label>
                            <input
                                className="form-control form-control-sm col-md-9"
                                type="text"
                                placeholder="P"
                                name="p"
                                value={this.state.data.p || ""}
                                onChange={this.handleChangeText}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <label className="col-md-3 col-form-label col-form-label-sm">
                              A
                            </label>
                            <input
                                className="form-control form-control-sm col-md-9"
                                type="text"
                                placeholder="A"
                                name="a"
                                value={this.state.data.a || ""}
                                onChange={this.handleChangeText}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Nifas
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="puerperal"
                              className="custom-control-input"
                              id="is_nifas1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.puerperal === true || this.state.data.puerperal === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="is_nifas1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="puerperal"
                              className="custom-control-input"
                              id="is_nifas2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.puerperal === false || this.state.data.puerperal === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="is_nifas2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Menyusui
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="breast_feed"
                              className="custom-control-input"
                              id="breast_feed1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.breast_feed === true || this.state.data.breast_feed === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="breast_feed1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="breast_feed"
                              className="custom-control-input"
                              id="breast_feed2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.breast_feed === false || this.state.data.breast_feed === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="breast_feed2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Sakit Kuning
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="jaundice"
                              className="custom-control-input"
                              id="jaundice1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.jaundice === true || this.state.data.jaundice === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="jaundice1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="jaundice"
                              className="custom-control-input"
                              id="jaundice2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.jaundice === false || this.state.data.jaundice === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="jaundice2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Pendarahan vagina
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="vaginal_bleeding"
                              className="custom-control-input"
                              id="vaginal_bleeding1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.vaginal_bleeding === true || this.state.data.vaginal_bleeding === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="vaginal_bleeding1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="vaginal_bleeding"
                              className="custom-control-input"
                              id="vaginal_bleeding2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.vaginal_bleeding === false || this.state.data.vaginal_bleeding === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="vaginal_bleeding2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Keputihan lama
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="long_vaginal_discharge"
                              className="custom-control-input"
                              id="long_vaginal_discharge1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.long_vaginal_discharge === true || this.state.data.long_vaginal_discharge === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="long_vaginal_discharge1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="long_vaginal_discharge"
                              className="custom-control-input"
                              id="long_vaginal_discharge2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.long_vaginal_discharge === false || this.state.data.long_vaginal_discharge === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="long_vaginal_discharge2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Tumor Payudara
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="breast_tumor"
                              className="custom-control-input"
                              id="breast_tumor1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.breast_tumor === true || this.state.data.breast_tumor === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="breast_tumor1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="breast_tumor"
                              className="custom-control-input"
                              id="breast_tumor2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.breast_tumor === false || this.state.data.breast_tumor === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="breast_tumor2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Tumor Rahim
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="ovarian_tumor"
                              className="custom-control-input"
                              id="ovarian_tumor1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.ovarian_tumor === true || this.state.data.ovarian_tumor === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="ovarian_tumor1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="ovarian_tumor"
                              className="custom-control-input"
                              id="ovarian_tumor2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.ovarian_tumor === false || this.state.data.ovarian_tumor === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="ovarian_tumor2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Tumor Indung Telur
                    </label>
                    <div className="col-md-7">
                      <div className="row c0l-md-12">
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="uterine_tumor"
                              className="custom-control-input"
                              id="uterine_tumor1"
                              type="radio"
                              value={true}
                              onChange={this.handleChangeText}
                              checked={this.state.data.uterine_tumor === true || this.state.data.uterine_tumor === 'true'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="uterine_tumor1"
                          >
                            Ya
                          </label>
                        </div>
                        <div className="custom-control custom-radio mb-3 col-md-4">
                          <input
                              name="uterine_tumor"
                              className="custom-control-input"
                              id="uterine_tumor2"
                              type="radio"
                              value={false}
                              onChange={this.handleChangeText}
                              checked={this.state.data.uterine_tumor === false || this.state.data.uterine_tumor === 'false'}
                          />
                          <label
                              className="custom-control-label"
                              htmlFor="uterine_tumor2"
                          >
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Tgl Dipesan Kembali
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <input
                            className="form-control form-control-sm"
                            type="date"
                            placeholder="Tgl Dipesan Kembali"
                            name="reorder_date"
                            value={this.state.data.reorder_date || ""}
                            onChange={this.handleChangeText}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
              <button className="btn btn-danger" onClick={this.onReload}>
                Tutup
              </button>
            </Form>
          )}
        </Formik>

        {/* <button className="btn btn-primary" onClick={this.handleSubmit}>
          Simpan
        </button>
        <button className='btn btn-danger' onClick={ this.onReload }>
          Tutup
        </button> */}
      </>
    );
  }
}

export default KbObjective;
